const attributesToFlatten = [
  "sku",
  "name",
  "price",
  "compare_at_price",
  "quantity",
];

const flattenCartItems = (items) => {
  return {
    productSkus: items
      .map((item, index) => {
        return `${index}: ${item.sku}`;
      })
      .join(", "),
    productNames: items
      .map((item, index) => {
        return `${index}: ${item.title}`;
      })
      .join(", "),
    productPrices: items
      .map((item, index) => {
        return `${index}: ${item.price}`;
      })
      .join(", "),
    productQuantities: items
      .map((item, index) => {
        return `${index}: ${item.quantity}`;
      })
      .join(", "),
    productImages: items
      .map((item, index) => {
        return `${index}: ${item.featured_image.url}`;
      })
      .join(", "),
  };
};

// Helper function to track events with additional data
function trackEvent(eventName, event) {
  const customData = {
    ...event.detail,
    // add more attriutes if required
  };
  // console.log("Event: MoE - ", eventName, customData);
  Moengage?.track_event(eventName, customData);
}

//Subscribe to USER_ATTRIBUTES
document.addEventListener("USER_ATTRIBUTES", (event) => {
  //   console.log('Pre Unique ID', event.detail.metafields.cult.cfuserid);
  // Moengage.add_unique_user_id(event.detail.metafields.cult.cfuserid);
  // console.log('Post Unique ID')
  try {
    Moengage.add_unique_user_id(event.detail.metafields.cult.cfuserid);
  } catch (err) {
    console.error(err);
  }
  // console.log('Post Unique ID: New User', event.detail.metafields.cult.cfuserid)
  Moengage.add_first_name(event.detail.firstName);
  Moengage.add_last_name(event.detail.lastName);
  Moengage.add_email(event.detail.metafields.cult.email);
  Moengage.add_mobile(event.detail.phone);
  Moengage.add_user_name(event.detail.firstName + " " + event.detail.lastName);
  Moengage.add_gender(event.detail.metafields.cult.gender);
  Moengage.add_birthday(new Date(event.detail.metafields.cult.dob));
});

// Subscribe to PAGE_VIEW event
document.addEventListener("PAGE_VIEW", (event) => {
  trackEvent("PAGE_VIEW", event);
});

// Subscribe to BUTTON_CLICK event
document.addEventListener("BUTTON_CLICK", (event) => {
  trackEvent("BUTTON_CLICK", event);
});

// Subscribe to LINK_CLICK event
document.addEventListener("LINK_CLICK", (event) => {
  trackEvent("LINK_CLICK", event);
});

// Subscribe to APPLY_SORT event
document.addEventListener("APPLY_SORT", (event) => {
  trackEvent("APPLY_SORT", event);
});

// Subscribe to APPLY_FILTER event
document.addEventListener("APPLY_FILTER", (event) => {
  trackEvent("APPLY_FILTER", event);
});

// Subscribe to CHECKOUT_CLICKED event
document.addEventListener("CHECKOUT_CLICKED", (event) => {
  let flattenedProductData = flattenCartItems(event.detail.cart.items);
  Object.keys(flattenedProductData).forEach((key) => {
    event.detail[key] = flattenedProductData[key];
  });
  event.detail.cartValue = event.detail.cart.total_price;
  event.detail.cartQuantity = event.detail.cart.item_count;
  trackEvent("CHECKOUT_CLICKED", event);
});

// Subscribe to LOGIN_INITIATED event
document.addEventListener("LOGIN_INITIATED", (event) => {
  trackEvent("LOGIN_INITIATED", event);
});

// Subscribe to LOGIN_STARTED event
document.addEventListener("LOGIN_STARTED", (event) => {
  trackEvent("LOGIN_STARTED", event);
});

// Subscribe to OTP_SUBMITTED event
document.addEventListener("OTP_SUBMITTED", (event) => {
  trackEvent("OTP_SUBMITTED", event);
});

// Subscribe to LOGIN_COMPLETED event
document.addEventListener("LOGIN_COMPLETED", (event) => {
  trackEvent("LOGIN_COMPLETED", event);
});

// Subscribe to SEARCH event
document.addEventListener("SEARCH", (event) => {
  trackEvent("SEARCH", event);
});

// Subscribe to VARIANT_SELECTED event
document.addEventListener("VARIANT_SELECTED", (event) => {
  event.detail.productSku = event.detail.selectedVariant.sku;
  event.detail.productName = event.detail.selectedVariant.name;
  event.detail.price = event.detail.selectedVariant.price;
  event.detail.compare_at_price = event.detail.selectedVariant.compare_at_price;
  event.detail.featured_image = event.detail.product.featured_image.src;
  trackEvent("VARIANT_SELECTED", event);
});

// Subscribe to ATC (Add To Cart) event
document.addEventListener("ATC", (event) => {
  event.detail.productSku = event.detail.selectedVariant.sku;
  event.detail.productName = event.detail.selectedVariant.name;
  event.detail.price = event.detail.selectedVariant.price;
  event.detail.compare_at_price = event.detail.selectedVariant.compare_at_price;
  event.detail.featured_image = event.detail.product.featured_image.src;
  event.detail.productType = event.detail.product.productType;
  trackEvent("ATC", event);
});

// Subscribe to CART_OPEN event
document.addEventListener("CART_OPEN", (event) => {
  let flattenedProductData = flattenCartItems(event.detail.cart.items);
  Object.keys(flattenedProductData).forEach((key) => {
    event.detail[key] = flattenedProductData[key];
  });
  event.detail.cartValue = event.detail.cart.total_price;
  event.detail.cartQuantity = event.detail.cart.item_count;
  trackEvent("CART_OPEN", event);
});

// Subscribe to CART_CLOSE event
document.addEventListener("CART_CLOSE", (event) => {
  let flattenedProductData = flattenCartItems(event.detail.cart.items);
  Object.keys(flattenedProductData).forEach((key) => {
    event.detail[key] = flattenedProductData[key];
  });
  event.detail.cartValue = event.detail.cart.total_price;
  event.detail.cartQuantity = event.detail.cart.item_count;
  trackEvent("CART_CLOSE", event);
});

// Subscribe to CART_UPDATE event
document.addEventListener("CART_UPDATE", (event) => {
  let flattenedProductData = flattenCartItems(event.detail.cart.items);
  Object.keys(flattenedProductData).forEach((key) => {
    event.detail[key] = flattenedProductData[key];
  });
  event.detail.cartValue = event.detail.cart.total_price;
  event.detail.cartQuantity = event.detail.cart.item_count;
  trackEvent("CART_UPDATE", event);
});

document.addEventListener("checkout_completed", (event) => {
  let checkoutCompletedEventData = {
    pageUrl: window.location.href,
    previousPageUrl: document.referrer,
    screenHeight: window.screen.height,
    screenWidth: window.screen.width,
    userAgent: navigator.userAgent,
    ...event.data,
  };

  Moengage.track_event("CHECKOUT_COMPLETED", checkoutCompletedEventData);
});

document.addEventListener("CHECKOUT_PROCESS", (event) => {
  let { checkoutEvent, ...rest } = event.detail;
  let checkoutProcessEventData = {
    pageUrl: window.location.href,
    previousPageUrl: document.referrer,
    screenHeight: window.screen.height,
    screenWidth: window.screen.width,
    userAgent: navigator.userAgent,
    ...rest,
  };
  trackEvent(checkoutEvent, { detail: checkoutProcessEventData });
});

document.addEventListener("LOGOUT", (event) => {
  Moengage.destroy_session();
});

document.addEventListener("weekender_game_started", (event) => {
  trackEvent("weekender_game_started", event);
});
document.addEventListener("weekender_tap", (event) => {
  trackEvent("weekender_tap", event);
});
document.addEventListener("weekender_game_won", (event) => {
  trackEvent("weekender_game_won", event);
});
document.addEventListener("weekender_game_lost", (event) => {
  trackEvent("weekender_game_lost", event);
});
document.addEventListener("weekender_coupon_copied", (event) => {
  trackEvent("weekender_coupon_copied", event);
});
document.addEventListener("weekender_game_won_coupon_shown", (event) => {
  trackEvent("weekender_game_won_coupon_shown", event);
});
document.addEventListener("weekender_game_won_coupon_not_shown", (event) => {
  trackEvent("weekender_game_won_coupon_not_shown", event);
});
